function setupPipSlider(root) {
  const slides = [...root.querySelectorAll('[data-pip-slide]')];
  const dots = [...root.querySelectorAll('[data-pip-dot]')];
  if (slides.length < 2) return;

  let index = 0;
  let timer;
  const delay = Number(root.dataset.delay) || 7000;

  const show = (next) => {
    index = (next + slides.length) % slides.length;
    slides.forEach((slide, i) => {
      const active = i === index;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', String(!active));
    });
    dots.forEach((dot, i) => {
      const active = i === index;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', String(active));
    });
  };

  const start = () => {
    window.clearInterval(timer);
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      timer = window.setInterval(() => show(index + 1), delay);
    }
  };

  root.querySelector('[data-pip-prev]')?.addEventListener('click', () => { show(index - 1); start(); });
  root.querySelector('[data-pip-next]')?.addEventListener('click', () => { show(index + 1); start(); });
  dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.pipDot)); start(); }));
  root.addEventListener('mouseenter', () => window.clearInterval(timer));
  root.addEventListener('mouseleave', start);
  start();
}

function setupPipRails(scope = document) {
  scope.querySelectorAll('[data-pip-rail]').forEach((button) => {
    if (button.dataset.pipReady) return;
    button.dataset.pipReady = 'true';
    button.addEventListener('click', () => {
      const rail = document.getElementById(button.getAttribute('aria-controls'));
      if (!rail) return;
      const card = rail.firstElementChild;
      const amount = card ? card.getBoundingClientRect().width + 24 : rail.clientWidth * 0.8;
      rail.scrollBy({ left: button.dataset.pipRail === 'prev' ? -amount : amount, behavior: 'smooth' });
    });
  });
}

function initPip(scope = document) {
  scope.querySelectorAll('[data-pip-slider]').forEach((root) => {
    if (root.dataset.pipReady) return;
    root.dataset.pipReady = 'true';
    setupPipSlider(root);
  });
  setupPipRails(scope);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initPip());
} else {
  initPip();
}

document.addEventListener('shopify:section:load', (event) => initPip(event.target));
